import { ButtonComponent } from "@/components";
import { WEB_COLORS } from "@/lib/constants";
import { Box, Grid, Stack, Typography } from "@mui/material";

const CustomStepIcon = ({ activeIndex, isLast }) => {
  return (
    <Box
      sx={{
        position: "relative", // anchor for the line
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        pl: activeIndex == 0 ? 0.6 : 1,
      }}
    >
      <Box
        sx={{
          width: "1px",
          height: {
            xs: activeIndex === 0 ? 120 : 70,
            md: activeIndex === 0 ? 90 : 40,
          }, // adjust as needed
          backgroundColor: activeIndex === 0 ? "none" : "#7F9893",
        }}
      ></Box>

      <Box
        sx={{
          width: activeIndex == 0 ? 16 : 10,
          height: activeIndex == 0 ? 16 : 10,
          border: activeIndex == 0 ? "6px solid #004135" : "1px solid #004135",
          backgroundColor: activeIndex == 0 ? "#00F200" : "#7F9893",
          borderRadius: "50%",
        }}
      ></Box>

      <Box
        sx={{
          width: "1px",
          height: {
            xs: activeIndex === 0 ? 120 : 70,
            md: activeIndex === 0 ? 80 : 40,
          }, // adjust as needed
          backgroundColor: isLast ? "none" : "#7F9893",
        }}
      ></Box>
    </Box>
  );
};
const StepperComponent = ({ steps, handleResumeJourney }) => {
  return (
    <div>
      {steps?.map((step, index) => (
        <Stack
          key={index}
          flexDirection={"row"}
          //   spacing={2}
          alignItems={"center"}
          gap={2}
        >
          <CustomStepIcon
            activeIndex={index}
            isLast={index === steps?.length - 1}
          />

          <Grid
            container
            xs
            sx={{
              border: "1px solid #7F9893",
              borderRadius: "12px",
              py: "12px",
              px: "20px",
              backgroundColor: index === 0 ? " #E5F1F1" : "#fff",
              //   width: "max-width",
              height: { md: "100%", xs: index === 0 ? "100%" : "120px" },
            }}
          >
            {index === 0 ? (
              <>
                <Grid
                  container
                  mb={2}
                  sx={{
                    justifyContent: "space-between",
                  }}
                  gap={1}
                >
                  <Box item sx={{ order: { xs: 2, sm: 1 } }}>
                    <Typography
                      fontWeight={{ md: 700, xs: 500 }}
                      fontSize={{ md: "20px", xs: "16px" }}
                    >
                      {step?.title}
                    </Typography>
                    <Typography fontWeight={400} fontSize={"14px"}>
                      {step?.content}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      p: 1,
                      px: 2,
                      backgroundColor: "#00F200",
                      borderRadius: "25px",
                      order: { xs: 1, md: 2 },
                      mb: { xs: 1, md: 0 },
                      width: { xs: "172px", md: "200px" },
                    }}
                    display={"flex"}
                    alignItems={"center"}
                    gap={1}
                  >
                    <Box
                      sx={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        backgroundColor: WEB_COLORS.darkTeal,
                      }}
                    ></Box>
                    <Typography
                      fontWeight={{ xs: 400, md: 500 }}
                      fontSize={{ xs: "10px", md: "12px" }}
                      color={WEB_COLORS.darkTeal}
                    >
                      You are currently here
                    </Typography>
                  </Box>
                </Grid>
                <ButtonComponent
                  stackWidth={"200px"}
                  onClick={handleResumeJourney}
                >
                  Resume Journey
                </ButtonComponent>
              </>
            ) : (
              <Stack
                flexDirection={"column"}
                // alignItems={"center"}
                justifyContent={"center"}
              >
                <Typography
                  color={"#727272"}
                  fontWeight={500}
                  fontSize={{ xs: "16px" }}
                >
                  {step?.title}
                </Typography>
                <Typography
                  color={"#727272"}
                  fontWeight={400}
                  fontSize={{ xs: "14px" }}
                >
                  {step?.content}
                </Typography>
              </Stack>
            )}
          </Grid>
        </Stack>
      ))}
    </div>
  );
};

export default StepperComponent;
